import styled from 'styled-components';
import theme from '../../theme';

export const Container = styled.section`
  background-color: ${theme.colors.primary3};
  align-items: center;
  padding: 13px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const IconContainer = styled.section`
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const Text = styled.span`
  color: ${theme.colors.title};
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const Button = styled.button`
  background-color: ${theme.colors.graph};
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 18px;
  padding-left: 18px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border-color: ${theme.colors.graph};
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const ButtonText = styled.span`
  color: ${theme.colors.title};
  font-weight: 600;
  text-transform: uppercase;
`;
